import api from './axios';
import { StorageData, StorageResponse, StorageListResponse, ApiResponse } from '../types/storage';
import { User } from '../types/user';
import { StorageHistoryEntry } from '../types/customer';

interface SearchParams {
  musteri?: string | null;
  plaka?: string | null;
  depo?: string | null;
  no?: string | null;
  not?: string | null;
  baslangicTarihi?: string | null;
  bitisTarihi?: string | null;
  showDeleted?: boolean;
}

interface GetAllParams {
  showDeleted?: boolean;
}

interface StorageHistoryResponse extends ApiResponse {
  data?: StorageHistoryEntry[];
}

export const storageApi = {
  getAll: (params?: GetAllParams) => api.get<StorageListResponse>('/storage', { params }),
  getById: (id: string) => api.get<StorageResponse>(`/storage/${id}`),
  getHistory: (id: string) => api.get<StorageHistoryResponse>(`/storage/${id}/history`),
  search: (params: SearchParams) => api.get<StorageListResponse>('/storage/search', { params }),
  create: (data: Partial<StorageData>) => api.post<StorageResponse>('/storage', data),
  update: (id: string, data: Partial<StorageData>) => api.put<StorageResponse>(`/storage/${id}`, data),
  delete: (id: string) => api.delete<StorageResponse>(`/storage/${id}`),
  restore: (id: string) => api.post<StorageResponse>(`/storage/${id}/restore`),
  import: (formData: FormData) => api.post<ApiResponse>('/storage/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  export: () => api.get('/storage/export', { responseType: 'blob' }),
  bulkDeactivate: (password: string) => api.post('/storage/bulk-deactivate', { password }),
  bulkDelete: (password: string) => api.post('/storage/bulk-delete', { password })
};

export const userApi = {
  getAll: () => api.get<{ data: User[] }>('/admin/users'),
  create: (data: Partial<User>) => api.post('/admin/users', data),
  update: (id: string, data: Partial<User>) => api.put(`/admin/users/${id}`, data),
  delete: (id: string) => api.delete(`/admin/users/${id}`),
  importData: (formData: FormData) => api.post('/admin/users/import', formData),
}; 